import { makeStyles } from '@material-ui/core/styles';
import { btNavyBlueColor } from '../../assets/jss/nextjs-material-kit-pro';
import { secondaryColor, webPrimaryColor, whiteColor } from '../../assets/jss/nextjs-material-kit-pro.js';

const formStyles = makeStyles((theme) => ({
  columnHeader: {
    height: 40,
    fontSize: '0.90rem',
    fontWeight: 'bold',
  },
  firstSectionSpacer: {
    height: 40,
    fontSize: '0.90rem',
    fontWeight: 'bold',
  },
  columnHeaders: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  sectionTitle: {
    backgroundColor: btNavyBlueColor,
    color: whiteColor,
    textTransform: 'uppercase',
    padding: 8,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.80rem',
      fontWeight: 600,
      margin: '10px 0',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '0.90rem',
      fontWeight: 600,
      margin: '20px 0',
    },
  },
  textRowLabelSpacer: {
    [theme.breakpoints.down('md')]: {
      height: 30,
      paddingTop: 5,
      overflow: 'auto',
    },
    [theme.breakpoints.up('md')]: {
      height: 50,
      paddingTop: 8,
      overflow: 'auto',
    },
  },
  buttonWidth: {
    width: 110,
  },
  buttonSpacer: {
    height: 50,
    marginTop: 20,
  },
  printedContent: {
    '@media print': {
      marginBottom: 10,
    },
    '@media screen': {
      display: 'none',
    },
  },
  unprintedContent: {
    '@media print': {
      display: 'none',
    },
    '@media screen': {},
  },
  floatingSaveButton: {
    position: 'absolute',
    right: 15,
    bottom: 15,
    margin: '0 15px 15px 0',
    width: '110px',
    '@media print': {
      display: 'none',
    },
    '@media screen': {},
  },
  error: {
    fontSize: '1.05rem',
    color: '#FA0000',
    fontWeight: 600,
  },
  floatingScore: {
    position: 'absolute',
    height: '110px',
    width: '110px',
    borderRadius: '50%',
    backgroundColor: secondaryColor,
    fontWeight: 600,
    fontSize: '1.25rem',
    color: whiteColor,
    '@media print': {
      display: 'none',
    },
    '@media screen': {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    [theme.breakpoints.up('lg')]: {
      top: '7.5%',
      left: '67%',
    },
    [theme.breakpoints.down('md')]: {
      top: '6%',
      left: '81%',
    },
    [theme.breakpoints.down('sm')]: {
      top: '4.5%',
      left: '78%',
    },
    [theme.breakpoints.down('xs')]: {
      top: '5.5%',
      left: '62%',
    },
  },
  printedScore: {
    width: '100%',
    fontWeight: 600,
    fontSize: '1.50rem',
    padding: '10px 0 10px 0',
    color: webPrimaryColor,
    '@media screen': {
      display: 'none',
    },
  },
  floatingScoreNumber: {
    padding: '30px 4px 5px 4px',
    width: '100%',
  },
  floatingScoreLabel: {
    padding: '0 4px 22px 4px',
    width: '100%',
  },
  footnote: {
    fontSize: '0.90rem',
    fontWeight: 700,
  },
  labelRowSpacer: {
    [theme.breakpoints.down('xs')]: {
      marginBottom: 15,
    },
    [theme.breakpoints.up('xs')]: {
      marginTop: 5,
    },
  },
  textRowSpacer: {
    [theme.breakpoints.down('xs')]: {
      marginBottom: 20,
    },
    [theme.breakpoints.up('xs')]: {
      height: 50,
    },
  },
  spacer2520: {
    margin: '25px 0 20px 0',
  },
  dispositionNote: {
    fontSize: '1.05rem',
    padding: '25px 15px',
    marginBottom: 30,
    '@media print': {},
    '@media screen': {
      border: '1px solid blue',
      backgroundColor: '#FFFAF0',
    },
  },
  warning: {
    backgroundColor: '#fdb515',
  },
  note: {
    color: 'blue',
  },
}));

export default formStyles;
